/**
 * This component doesn't actually render anything. It is a prop container that
 * gets passed to `NormalizedListView`. The actual `ActionGroup` elements will
 * be created from this component's props on each item in the list view.
 */
export function ListActionGroup(_props) {
  return null;
}
//# sourceMappingURL=ListActionGroup.js.map